export const getFileId = (f: Record<string, any>) => {
  if (f.id) return f.id
  if (typeof f.uid === 'string' && f.response) {
    return Number(f.response?.uid) as unknown as bigint
  }
  if (f.uid) {
    return Number(f.uid) as unknown as bigint
  }
}
